
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic16Static as ObiHydraulic16StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-16-static.js';
 
 
 

 
 export const ObiHydraulic16Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-16-static',
   elementClass: ObiHydraulic16StaticElement,
   events: {
     
   }
  });
 
 